import { useUserInfo } from "@/context/UserInfo";
import { accDiv, accMul, toFixed } from "@/utils/formatBalance";
import { useMemo } from "react";

export const useCurrencyExchange = () => {
  const { showUsd, currencyInfo } = useUserInfo();

  const currencyUnit = useMemo(() => {
    return showUsd ? "USD" : currencyInfo.localCurrency;
  }, [showUsd, currencyInfo.localCurrency]);

  const usdToCurrency = (amount: string | number | undefined) => {
    if (!amount) {
      return "0";
    }

    if (showUsd) {
      return String(amount);
    } else {
      return toFixed(accMul(amount, currencyInfo.exchangeRate), 0);
    }
  };

  function localConvertToUsd(amount: string | number | undefined): string {
    if (!amount) {
      return "0";
    }

    // 获取汇率
    const rate = currencyInfo.exchangeRate;

    // 将其他货币转换为 USD
    return toFixed(accDiv(amount, rate), 0);
  }

  return { usdToCurrency, localConvertToUsd, currencyUnit };
};
